import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { TermsData } from 'sections/Resources/FreightDictionary/data';
import { TermType, TermItem } from 'sections/Resources/FreightDictionary/types';
import { TermsList } from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList';
import { Term } from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/Term';
import { useSearchTerm } from 'sections/Resources/FreightDictionary/hooks/useSearchTerm';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/TermsListContainer/TermsListContainer.module.scss';

const cn = classNames.bind(styles);

const TermsListContainer = (): ReactElement => {
  const { foundTerms, isSearchActive } = useSearchTerm();

  const renderElements = () => {
    if (isSearchActive) {
      return foundTerms.map((item: TermItem) => {
        return (
          <Term
            key={`${item.id}_${item.name}`}
            name={item.name}
            url={item.url}
            description={item.description}
          />
        );
      });
    } else {
      return TermsData.map((item: TermType) => {
        if (!item.terms.length) return;
        return (
          <TermsList
            key={item.id}
            id={item.id}
            label={item.label}
            terms={item.terms}
          />
        );
      });
    }
  };

  return (
    <ul className={cn('terms-list-container', { 'searched': isSearchActive })}>
      {renderElements()}
    </ul>
  );
};

export { TermsListContainer };